import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot } from "@angular/router";

@Injectable({ providedIn: "root" })
export class ExternalRedirectGuard implements CanActivate {
  redirectBaseUrl;
  constructor() {
    this.redirectBaseUrl = (window as any).__env.redirectToPizgloria3_0;
  }
  // canActivate(route: ActivatedRouteSnapshot): boolean {
  //   const token = sessionStorage.getItem("userData");
  //   const pageId = route.routeConfig?.path;

  //   const url = `${this.redirectBaseUrl}${pageId}?auth=${encodeURIComponent(token)}`;
  //   window.open(url, "_blank");

  //   return false; // stop Angular routing
  // }
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const pageId = route.routeConfig?.path;
    const url = `${this.redirectBaseUrl}${pageId}`;
    window.open(url, "_blank");
    return false;
  }
}
